import { EBusinessType } from '../../../../../types/businessType';

export function getIsBusinessCategory(
  readyBusinessType: EBusinessType | undefined,
): Record<`is${Capitalize<'readyBusiness' | 'rentalBusiness'>}`, boolean> {
  return {
    isReadyBusiness: readyBusinessType === EBusinessType.ReadyBusiness || readyBusinessType === EBusinessType.Other,
    isRentalBusiness: readyBusinessType === EBusinessType.RentalBusiness,
  };
}
